var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99414 15.1919C7.99414 15.6387 8.35303 15.9976 8.7998 15.9976C9.24658 15.9976 9.60547 15.6387 9.60547 15.1919V14.7085C9.60547 13.5439 10.4111 12.7749 11.6123 12.7749H17.1348V14.3057C17.1348 14.7012 17.3911 14.9502 17.7939 14.9502C17.9697 14.9502 18.1528 14.8843 18.292 14.7671L21.0605 12.4819C21.3901 12.2183 21.3828 11.7788 21.0605 11.5005L18.292 9.20068C18.1528 9.09082 17.9697 9.01758 17.7939 9.01758C17.3911 9.01758 17.1348 9.27393 17.1348 9.66943V11.1855H11.7661C9.45898 11.1855 7.99414 12.5112 7.99414 14.5913V15.1919ZM14.8569 17.1548C14.8569 16.7593 14.6079 16.5103 14.1978 16.5103C14.022 16.5103 13.8389 16.5762 13.707 16.686L10.9385 18.9712C10.6089 19.2422 10.6016 19.6743 10.9385 19.9526L13.707 22.2524C13.8389 22.3696 14.022 22.4355 14.1978 22.4355C14.6079 22.4355 14.8569 22.1865 14.8569 21.791V20.2603H20.2256C22.5327 20.2603 23.9976 18.9272 23.9976 16.8545V16.2539C23.9976 15.7998 23.6387 15.4409 23.1919 15.4409C22.7451 15.4409 22.3862 15.7998 22.3862 16.2539V16.7373C22.3862 17.8945 21.5806 18.6709 20.3794 18.6709H14.8569V17.1548Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlip);
export default __webpack_public_path__ + "static/media/Flip.cd08bef0a72c90186fa920e4c2a4978c.svg";
export { ForwardRef as ReactComponent };